import { gql } from '@apollo/client';
import config from 'config';

const styleConversationIndex = config.algolia.algolia_prefix + 'style_conversation';

export const GET_CONVERSATION = gql`
    query getConversation($input: GetConversationInput!) {
        conversations(input: $input) {
            paging {
                page
                size
            }
            data {
                id
                chatbotProfileId
                userId
                recommendedElements {
                    role
                    content
                    dynamicContent
                    visible
                    scope
                    created
                    answer
                    taffiId
                    type
                    required
                    i18n
                    language
                    elements {
                        template
                        type
                        label
                        dynamicLabel
                        value
                        url
                        message
                        productId
                        productType
                        productTaffiId
                        stylistId
                        stylistEmail
                        stylistFirstName
                        stylistLastName
                        collectionName
                        functionName
                        labelI18n
                        messageI18n
                        storeProductId
                        storeIds
                        labels {
                            id
                            name
                        }
                        items {
                            id
                            creator
                            price
                            currency
                            storeUrl
                            taffiId
                            taffiUrl
                            title
                            category
                            images
                            style_image
                            image_metadata
                            storeProductId
                            backgroundRemovedMap {
                                backgroundRemovedUrl
                                originalUrl
                                width
                                height
                                xmin
                                xmax
                                ymin
                                ymax
                            }
                            store {
                                id
                                taffiId
                                name
                                url
                                shopifyDomain
                                platform
                            }
                        }
                        imageJson
                    }
                }
                messages {
                    id
                    role
                    content
                    dynamicContent
                    visible
                    scope
                    created
                    answer
                    conversationId
                    taffiId
                    type
                    required
                    i18n
                    language
                    elements {
                        template
                        type
                        label
                        dynamicLabel
                        value
                        url
                        message
                        productId
                        productType
                        productTaffiId
                        stylistId
                        stylistEmail
                        stylistFirstName
                        stylistLastName
                        collectionName
                        functionName
                        labelI18n
                        messageI18n
                        storeProductId
                        storeIds
                        labels {
                            id
                            name
                        }
                        items {
                            id
                            creator
                            price
                            currency
                            storeUrl
                            taffiId
                            taffiUrl
                            title
                            category
                            images
                            style_image
                            image_metadata
                            storeProductId
                            backgroundRemovedMap {
                                backgroundRemovedUrl
                                originalUrl
                                width
                                height
                                xmin
                                xmax
                                ymin
                                ymax
                            }
                            store {
                                id
                                taffiId
                                name
                                url
                                shopifyDomain
                                platform
                            }
                        }
                        imageJson
                    }
                }
                status
                gender
                birthday
                language
                created
                creator
                updated
                updater
            }
        }
    }
`;
export const GET_SINGLE_CONVERSATION = gql`
    query getSingleConversation($input: GetSingleConversationInput!) {
        getSingleConversation(input: $input) {
            id
            chatbotProfileId
            userId
            recommendedElements {
                role
                content
                dynamicContent
                visible
                scope
                created
                answer
                taffiId
                type
                required
                i18n
                language
                elements {
                    template
                    type
                    label
                    dynamicLabel
                    value
                    url
                    message
                    productId
                    productType
                    productTaffiId
                    stylistId
                    stylistEmail
                    stylistFirstName
                    stylistLastName
                    collectionName
                    functionName
                    labelI18n
                    messageI18n
                    storeProductId
                    storeIds
                    labels {
                        id
                        name
                    }
                    items {
                        id
                        creator
                        price
                        currency
                        storeUrl
                        taffiId
                        taffiUrl
                        title
                        category
                        images
                        style_image
                        image_metadata
                        storeProductId
                        backgroundRemovedMap {
                            backgroundRemovedUrl
                            originalUrl
                            width
                            height
                            xmin
                            xmax
                            ymin
                            ymax
                        }
                        store {
                            id
                            taffiId
                            name
                            url
                            shopifyDomain
                            platform
                        }
                    }
                    imageJson
                }
            }
            messages {
                id
                role
                content
                dynamicContent
                visible
                scope
                created
                answer
                conversationId
                taffiId
                type
                required
                i18n
                language
                elements {
                    template
                    type
                    label
                    dynamicLabel
                    value
                    url
                    message
                    productId
                    productType
                    productTaffiId
                    stylistId
                    stylistEmail
                    stylistFirstName
                    stylistLastName
                    collectionName
                    functionName
                    labelI18n
                    messageI18n
                    storeProductId
                    storeIds
                    labels {
                        id
                        name
                    }
                    items {
                        id
                        creator
                        price
                        currency
                        storeUrl
                        taffiId
                        taffiUrl
                        title
                        category
                        images
                        style_image
                        image_metadata
                        storeProductId
                        backgroundRemovedMap {
                            backgroundRemovedUrl
                            originalUrl
                            width
                            height
                            xmin
                            xmax
                            ymin
                            ymax
                        }
                        store {
                            id
                            taffiId
                            name
                            url
                            shopifyDomain
                            platform
                        }
                    }
                    imageJson
                }
            }
            status
            gender
            birthday
            language
            created
            creator
            updated
            updater
        }
    }
`;

export const GET_CONVERSATION_LIST = gql`
query AlgoliaGetConversation ($query : String!, $filters: String!, $hit : Number!, $page : Number!) {
  algoliaGetConversation @algolia(__typename: "ALGOLIA_GET_STYLE_CONVERSATION_LIST", index: ${styleConversationIndex}, filters: $filters, hitsPerPage: $hit, query: $query, page: $page) {
      hits
      nbHits
      facets
      page
      nbPages
  }
}
`;

export const GET_CONSUMER_CONVERSATION = gql`
    query getConsumerConversations($input: GetConsumerConversationInput!) {
        getConsumerConversations(input: $input) {
            paging {
                page
                size
            }
            data {
                id
                chatbotProfileId
                userId
                messages {
                    id
                    role
                    content
                    dynamicContent
                    visible
                    scope
                    created
                    answer
                    conversationId
                    taffiId
                    type
                    required
                    i18n
                    language
                    elements {
                        type
                        label
                        dynamicLabel
                        value
                        url
                        message
                        productId
                        productType
                        productTaffiId
                        stylistId
                        stylistEmail
                        stylistFirstName
                        stylistLastName
                        collectionName
                        functionName
                        labelI18n
                        messageI18n
                        storeProductId
                        storeIds
                        labels {
                            id
                            name
                        }
                        items {
                            id
                            creator
                            price
                            currency
                            storeUrl
                            taffiId
                            taffiUrl
                            title
                            category
                            images
                            style_image
                            image_metadata
                            storeProductId
                            store {
                                id
                                taffiId
                                name
                                url
                                shopifyDomain
                                platform
                            }
                            backgroundRemovedMap {
                                originalUrl
                                backgroundRemovedUrl
                                width
                                height
                                xmin
                                xmax
                                ymin
                                ymax
                            }
                        }
                    }
                }
                status
                gender
                birthday
                language
                created
                creator
                updated
                updater
            }
        }
    }
`;
